module.exports = __webpack_public_path__ + "static/media/activity-filter.0a8cdd8e.svg";